import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { OidcUaaConfig, QUERY_KEY_RETURN_URL } from '@lexi/oidc-uaa';
import { AuthService } from '../settings/auth.service';

@Injectable({
  providedIn: 'root'
})
export class IsCurrentUserRootGuard  {

  constructor(
    private authService: AuthService,
    private router: Router,
    private config: OidcUaaConfig
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if(this.authService.authenticatedUser?.isRoot) {
      return true;
    }

    this.router.navigate([this.config.openIDConfiguration?.forbiddenRoute ?? '/'], { queryParams: { [QUERY_KEY_RETURN_URL]: state.url }});
    return false;
  }

}
